import React from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"

const Footer = () => {
  const footerLinks = [
    {
      title: "Company",
      items: [
        { displayText: "About", url: "" },
        {
          displayText: "Testimonials",
          url: "",
        },
        { displayText: "Find a Doctor", url: "" },
        { displayText: "Apps", url: "" },
      ],
    },
    {
      title: "Help",
      items: [
        { displayText: "Help Center", url: "" },
        { displayText: "Contact Support", url: "" },
        { displayText: "Instructions", url: "" },
        { displayText: "How it works", url: "" },
      ],
    },
  ]

  return (
    <React.Fragment >
      <Box className="footer">
        <Grid 
          container
          style={{
            margin: `0 auto`,
            maxWidth: '90vw',
            minHeight: '100 vh',
            color: "#FFF",
          }}
        >
          <Grid
            xs={12}
            sm={12}
            item
            container
            direction="column"
            justify="center"
            alignItems="center"
            style={{ padding: 10,}}
          >
            <Typography variant="body2" color="inherit">
              ©Integrative Case Management 2020. All rights reserved
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  )
}
export default Footer
